import { Check, X } from 'lucide-react';
import logoImage from '../../../assets/images/logo.png'; // adjust relative path

const steps = [
  'Credenciales',
  'Confirmación de mail',
  'Verificación de identidad',
];

export default function RegisterHeader({ currentStep, onClose }) {
  const n = steps.length;

  return (
    <div className="bg-[#2A59C6] text-white py-6 lg:py-10 px-8 md:px-10 lg:px-20 space-y-3 lg:space-y-6 rounded-t-[0px] lg:rounded-t-[20px]">
      <div className="flex items-center justify-between">
        <div
          className="w-23 h-10 bg-cover bg-center"
          style={{ backgroundImage: `url(${logoImage})`, borderRadius: 15 }}
        ></div>
        <button
          onClick={onClose}
          className="flex items-center justify-center cursor-pointer"
        >
          <X className="w-5 h-5 sm:w-6 sm:h-8 lg:w-8 lg:h-8" />
        </button>
      </div>

      <div className="font-[poppins] leading-[20px] tracking-[0%] py-0 md:py-3 md:px-10 lg:px-32">
        <div className="flex">
          {steps.map((label, index) => {
            return (
              <div
                key={index}
                className={`flex flex-col ${
                  !index
                    ? 'text-left'
                    : index == n - 1
                    ? 'text-right'
                    : 'text-center'
                }`}
                style={{ flex: !index || index == n - 1 ? 1 : 2 }}
              >
                <div className="pb-1">
                  <div
                    className={`h-4 relative flex items-center ${
                      !index
                        ? 'justify-starter'
                        : index == n - 1
                        ? 'justify-end'
                        : 'justify-center'
                    }`}
                  >
                    {index < currentStep && (
                      <div className="z-1 p-[3px] bg-blue-300 rounded-full">
                        <Check className="w-[10px] h-[10px]" />
                      </div>
                    )}

                    {index == currentStep && (
                      <div className="z-1 w-4 h-4 rounded-full bg-[#092F7B] border border-1 border-white flex items-center justify-center">
                        <div className="w-2 h-2 rounded-full bg-white"></div>
                      </div>
                    )}
                    {index > currentStep && (
                      <div className="z-1 w-4 h-4 rounded-full bg-gray-300 border border-4 border-white"></div>
                    )}

                    <div
                      className={`absolute top-[7px] left-0 w-1/2 h-[2px] ${
                        index < currentStep ||
                        (index == currentStep && currentStep)
                          ? 'bg-white'
                          : 'bg-blue-300 opacity-50'
                      }`}
                    ></div>

                    <div
                      className={`absolute top-[7px] right-0 w-1/2 h-[2px] ${
                        index < currentStep ||
                        (index == currentStep && currentStep == n - 1)
                          ? 'bg-white'
                          : 'bg-blue-300 opacity-50'
                      }`}
                    ></div>
                  </div>
                </div>
                <div
                  className={`font-[poppins] text-xs tracking-[0%] ${
                    index == currentStep
                      ? 'font-semibold leading-[22px]'
                      : 'opacity-50 font-normal leading-[20px]'
                  }`}
                >
                  {label}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
